export const findTask = (state, action) => {
  const { task_id, column_id, tenant_id } = action.meta.arg;
  const tasks = state.columnsByTenants?.[tenant_id]?.[column_id]?.tasks;

  if (!tasks) return;

  const task = tasks.find((t) => t.id === task_id);
  return task;
};

export const updateCommentReactionPending = (state, action) => {
  const task = findTask(state, action);

  if (!task) return;

  const { id, user_id, emoji } = action.meta.arg;
  const comment = task.comments.find((c) => c.id === id);

  if (!comment?.reactions) comment.reactions = [];

  const reactionIndex = comment.reactions.findIndex(
    (r) => r.user_id === user_id,
  );

  if (reactionIndex !== -1) {
    if (comment.reactions[reactionIndex].emoji === emoji) {
      // Toggle off (remove reaction)
      comment.reactions.splice(reactionIndex, 1);
    } else {
      // Change emoji
      comment.reactions[reactionIndex].emoji = emoji;
    }
  } else {
    // Add new reaction
    comment.reactions.push({
      user_id,
      emoji,
    });
  }
};

export const addEditCommentFulfilled = (state, action) => {
  const task = findTask(state, action);

  if (!task) return;
  const { id } = action.meta.arg;
  const { data } = action.payload;

  if (!task.comments) {
    task.comments = [];
  }

  if (id) {
    const index = task.comments.findIndex((comment) => comment.id === data.id);

    if (index !== -1) {
      task.comments[index] = data;
    }
  } else {
    task.comments.unshift(data);
  }
};

export const addTaskAttachmentFulfilled = (state, action) => {
  const task = findTask(state, action);
  if (!task) return;

  const { data } = action.payload;
  if (!task.attachments) task.attachments = [];

  task.attachments.unshift(data);
};

export const updateFileKeyFulfilled = (state, action) => {
  const task = findTask(state, action);

  if (!task?.attachments) return;

  const { url } = action.payload;
  const { task_attachment_id } = action.meta.arg;

  const attachment = task.attachments.find(
    (item) => item.id === task_attachment_id,
  );

  if (attachment) attachment.storage_url = url;
};
